import { t } from 'ember-intl';
import QuestionsLoanTypesCard from 'tio-employee/components/questions/loan-types-card';
import { VStack } from 'tio-reimagined/components/layout';
import { PhCurrencyDollar, PhPercent, PhWarning, PhCaretDoubleRight } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

interface CircleSignature {
  Args: {
    label: string;
  };
}

const Circle: TOC<CircleSignature> = <template>
  <div
    class="shrink-0 w-6 h-6 bg-cyan-600 mr-2 text-white rounded-full text-center items-center inline-block"
  >
    {{@label}}
  </div>
</template>;

<template>
  <VStack class="px-4">
    <h3 class="text-center font-semibold mt-4">
      {{t "questions_you_have.types_of_student_loans.pros.pros_private"}}
    </h3>
    <div class="flex flex-col md:flex-row flex-wrap">
      <QuestionsLoanTypesCard
        @icon={{PhCurrencyDollar}}
        @label={{t "questions_you_have.types_of_student_loans.pros.pros_private_text"}}
        class="w-full"
      />
    </div>

    <h3 class="text-center font-semibold mt-4">
      {{t "questions_you_have.types_of_student_loans.cons.cons_private"}}
    </h3>
    <div class="flex flex-col md:flex-row flex-wrap">
      <QuestionsLoanTypesCard
        @icon={{PhPercent}}
        @label={{t "questions_you_have.types_of_student_loans.cons.generally_higher_interest_rate"}}
        class="w-full md:w-1/3 md:border-r"
      />
      <QuestionsLoanTypesCard
        @icon={{PhWarning}}
        @label={{t
          "questions_you_have.types_of_student_loans.cons.dont_have_repayment_plan_flexibility"
        }}
        class="w-full md:w-1/3 md:border-r"
      />
      <QuestionsLoanTypesCard
        @icon={{PhCaretDoubleRight}}
        @label={{t "questions_you_have.types_of_student_loans.cons.very_few_options"}}
        class="w-full md:w-1/3"
      />
    </div>
  </VStack>

  <div class="p-4">
    <h2 class="py-4 font-medium text-xl">
      {{t "questions_you_have.how_to_apply.default"}}
    </h2>
    <div class="py-4">
      <h3 class="font-semibold truncate text-left">
        <Circle @label={{t "number_one"}} />
        {{t "questions_you_have.how_to_apply.decide_if_cosigner.default" htmlSafe=true}}
      </h3>

      <ul class="list-disc ml-12 mb-4">
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.decide_if_cosigner.point_1"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.decide_if_cosigner.point_2"}}
        </li>
      </ul>
    </div>
    <div class="py-4">
      <h3 class="font-semibold truncate text-left">
        <Circle @label={{t "number_two"}} />
        {{t "questions_you_have.how_to_apply.check_application_requirements.default" htmlSafe=true}}
      </h3>
      <p class="ml-12 mt-4">
        {{t "questions_you_have.how_to_apply.check_requirements_private.header"}}
      </p>
      <ul class="list-disc ml-12 mb-4">
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.check_requirements_private.point_1"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.check_requirements_private.point_2"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.check_requirements_private.point_3"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.check_requirements_private.point_4"}}
        </li>
        <li class="m-4">
          {{t "questions_you_have.how_to_apply.check_requirements_private.point_5"}}
        </li>
      </ul>
    </div>
  </div>
</template>
